module.exports = __webpack_public_path__ + "img/fontello.d4a64a1.svg";